import Image from "next/image";
import palmeraImage from "@/public/img/products/palmera-showcase.png";
import neotericImage from "@/public/img/products/neoteric-showcase.png";
import { useTranslation } from "next-i18next";
import { m } from "framer-motion";
import { useMediaQuery } from "usehooks-ts";
import React from "react";

const BrandsSection = () => {
  const { i18n } = useTranslation();
  const [key, setKey] = React.useState(0);
  const rtl = i18n.dir() === "rtl";

  const isXs = useMediaQuery("(max-width: 600px)", {
    initializeWithValue: false,
  });
  const isSm = useMediaQuery("(min-width: 600px) and (max-width: 900px)", {
    initializeWithValue: false,
  });

  React.useEffect(() => {
    setKey(isXs ? 1 : isSm ? 2 : 3);
  }, [isXs, isSm]);

  return (
    <section className="flex w-full flex-col items-center justify-center  py-16">
      <div className="container flex flex-col items-start justify-center gap-10 px-4">
        <m.div
          className="flex w-full flex-col items-start justify-center gap-5"
          initial={{ opacity: 0 }}
          whileInView={{
            opacity: 1,
            transition: { duration: 0.5, ease: "easeOut" },
          }}
          viewport={{ once: true }}
        >
          <h2 className="text-4xl font-bold text-primary-700">Our Brands</h2>
          <div className="text-base font-medium leading-normal text-auto-black/60">
            We are proud to offer the best brands in the market. Our products
            are designed to meet the highest standards of quality. We also offer
            to pack our products in your brand.
          </div>
        </m.div>
        <div
          key={key}
          className="grid w-full grid-cols-1 items-center justify-center gap-8 sm:grid-cols-2"
        >
          <m.div
            className="relative  flex h-52 w-full flex-row items-center justify-center md:h-80 lg:h-96"
            initial={
              isXs
                ? { opacity: 0, y: -50 }
                : { opacity: 0, x: rtl ? 100 : -100 }
            }
            whileInView={{
              opacity: 1,
              x: 0,
              y: 0,
              transition: { duration: 0.5, ease: "easeOut" },
            }}
            viewport={{ once: true }}
          >
            <Image
              src={palmeraImage}
              alt="Palmera"
              fill
              className="absolute inset-0 object-contain object-center"
              sizes="(max-width: 600px) 375px, (max-width: 900px) 375px, (max-width: 1200px) 425px, 575px"
            />
          </m.div>
          <m.div
            className="relative flex h-52 w-full flex-row items-center justify-center md:h-80 lg:h-96"
            initial={
              isXs
                ? { opacity: 0, y: -50 }
                : { opacity: 0, x: rtl ? -100 : 100 }
            }
            whileInView={{
              opacity: 1,
              x: 0,
              y: 0,
              transition: { duration: 0.5, ease: "easeOut" },
            }}
            viewport={{ once: true }}
          >
            <Image
              src={neotericImage}
              alt="Neoteric"
              fill
              className="absolute inset-0 object-contain object-center"
              sizes="(max-width: 600px) 375px, (max-width: 900px) 375px, (max-width: 1200px) 425px, 575px"
            />
          </m.div>
        </div>
      </div>
    </section>
  );
};

export default BrandsSection;
